import { render, staticRenderFns } from "./InstantActivateSuccess.vue?vue&type=template&id=06fc4117&scoped=true"
import script from "./InstantActivateSuccess.vue?vue&type=script&lang=js"
export * from "./InstantActivateSuccess.vue?vue&type=script&lang=js"
import style0 from "./InstantActivateSuccess.vue?vue&type=style&index=0&id=06fc4117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc4117",
  null
  
)

export default component.exports